
import { css } from 'lit';
export default css`
#google_translate_element {
  display: none;
}`;